import parsePhoneNumberFromString, { CountryCode } from "libphonenumber-js";
import { CreateEmployeeFormValuesType } from "../../components/employees/AddUser";
import { Employee, Employer, Membership, TagReference } from "../../models";
    
export const createUser = async (
        formValues: CreateEmployeeFormValuesType, 
        countryCode: CountryCode,
        employees: Employee[] | undefined,
        membership: Membership | undefined,
        API_URL: string,
        employer: Employer | undefined,
        token: string | undefined,
        sendInvitationEmail: boolean,
        tags: TagReference[]
    ) => {
        if (
            employees?.length &&
            membership?.features?.maxEmployeeCount &&
            employees.length >= membership.features.maxEmployeeCount
        ) {
            throw new Error("User limit reached.");
        }

        const formattedPhoneNumber = parsePhoneNumberFromString(
          formValues.contact.phone,
          countryCode
        )?.number;

        const createEmployeeResponse = await fetch(
            `${API_URL}/employers/${employer?.id}/employees`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                customerEmployeeId: formValues.customerEmployeeId,
                firstName: formValues.firstName,
                lastName: formValues.lastName,
                sendInvitationEmail,
                contact: {
                  email: formValues.contact.email,
                  phone: formattedPhoneNumber,
                  address: {
                    country: employer?.country.id ?? ""
                  }
                },
                tags
              })
            }
          );
    
          const responseJson = await createEmployeeResponse.json();
          if (!createEmployeeResponse.ok) {
    
            switch (createEmployeeResponse.status) {
              case 409:
                throw new Error(
                  "This email already exists or the account has been deleted. Please contact support"
                );
              case 400:
                if (responseJson.errors["Contact.Phone"]) {
                  throw new Error(responseJson.errors["Contact.Phone"][0]);
                } else if (responseJson.errors["Contact.Email"]) {
                  throw new Error(responseJson.errors["Contact.Email"][0]);
                } else {
                  throw new Error("There was a problem adding this user");
                }
              default:
                throw new Error("There was a problem adding this user");
            }
          }
          
          return responseJson;
        }
    